import { render, staticRenderFns } from "./collectionModal.vue?vue&type=template&id=20d8a6d4&scoped=true&"
import script from "./collectionModal.vue?vue&type=script&lang=js&"
export * from "./collectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d8a6d4",
  null
  
)

export default component.exports